export enum ValidationType {
  Create = 'create',
  Update = 'update',
}
